<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
    if (this.$isMobile()) {
      this.$router.replace("/mobile/index");
    } else {
      this.$router.replace("/");
    }
  },
};
</script>

<style>
#app {
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue